export default "__VITE_ASSET__edYtdZuD__"